import { notEmpty } from '@ezchops/helpers';
import { AbcNote, Pad } from '@ezchops/musicsheet/lib/convert/sheetToAbc';
// @ts-ignore
import { Abc } from './abc2svg-1';
export function abc2svg(voice, signature, unitNoteLength, style) {
    const fullAbc = abcNotation(voice, signature, unitNoteLength, style);
    return fullAbc2svg(fullAbc, style.singleline == true);
}
export function fullAbc2svg(fullAbc, barRects) {
    const callbacks = new Abc2SvgCallbacks(barRects);
    const abc = new Abc(callbacks);
    callbacks.abc = abc;
    try {
        abc.tosvg('ABC NOTATION', fullAbc);
    }
    catch (e) {
        callbacks.errbld('error', e.message, undefined, undefined, undefined);
    }
    if (callbacks.errors.length == 0 || callbacks.errors.every(e => e.severity_level == 'warn')) {
        return [callbacks.svg, null];
    }
    const errorMessage = callbacks.errors.map(e => `${e.severity_level} in line ${e.line_number}: ${e.message}`).join('\n');
    return [null, callbacks.errors];
}
const header = (signature, unitNoteLength) => {
    return `%
X:6
T:
M:${signature.numerator}/${signature.denominator}
L:1/${unitNoteLength}`;
};
export function abcNotationWithoutStyle(voices, signature, unitNoteLength) {
    return `%
%abc
%%fullsvg _${Abc2SvgCallbacks.nextId}
${drumVoiceMap}
${header(signature, unitNoteLength)}
%
${staves(voices)}`;
}
export function abcNotation(voices, signature, unitNoteLength, style) {
    return `%
%abc
%%fullsvg _${Abc2SvgCallbacks.nextId}
${styleHeader(style)}
${shapes}
${decorations}
${drumVoiceMap}
${header(signature, unitNoteLength)}
%
${staves(voices)}`;
}
function staves(voices) {
    if (typeof voices == 'string') {
        return `%%score (Drums)
K:C clef=perc
V:Drums stem=up
%%voicemap drum
${voices}`;
    }
    else {
        const keys = ['hands', 'feet', 'sticking'];
        const staves = keys.filter(k => voices[k] != null);
        return `%%score (${staves.join(' ')})
K:C clef=perc
${staves.map(s => stave(s, voices[s])).filter(notEmpty).join('\n')}`;
    }
    function stave(key, voice) {
        return voice != null ? `V:${key}${key == 'hands' ? ' stem=up' : key == 'feet' ? ' stem=down' : ''}
%%voicemap drum
%%tuplets ${key == 'hands' ? '0 0 0 1' : key == 'feet' ? '0 0 0 2' : '1 0 0 0'}
${voice}` : null;
    }
}
const shapes = `%
%%beginsvg
    <style>
      .bar-rect {
        fill: transparent;
        z-index: 15;
      }
    </style>
    <defs>
        <text id="triangle" style="text-anchor: middle"></text>
        <text id="xhead" style="text-anchor: middle"></text>
        <text id="smallhead" transform="translate(1 0)" style="font-size: 0.7em; text-anchor: middle"></text>
        <text id="slash"></text>
    </defs>
%%endsvg`;
const drumVoiceMap = `%
%%map drum ${AbcNote[Pad.Crash]} heads=xhead print=c'   % Crash
%%map drum ${AbcNote[Pad.ClosedHiHat]} heads=xhead print=g       % Hi-Hat
%%map drum ${AbcNote[Pad.Ride]} heads=xhead print=A'   % Ride
%%map drum ${AbcNote[Pad.RideBell]} heads=triangle print=A' % Ride Bell
%%map drum ${AbcNote[Pad.PedalHiHat]} heads=xhead print=d,'   % Pedal hihat
%`;
const decorations = `%
%%deco ghost 9 smallhead 0 0 0
%%deco impro 9 slash 10 0 0`;
function styleHeader(style) {
    const { width, stretchlast, stretchstaff, equalbars, maxshrink, singleline, inline, scale, color, background, barsperstaff, musicfont } = style;
    return `%
${width != null ? `%%pagewidth ${width}` : '%'}
%%stretchstaff ${(stretchstaff ?? false) ? 1 : 0}
%%stretchlast ${stretchlast ?? 0.25}
%%equalbars ${(equalbars ?? false) ? 1 : 0}
%%singleline ${singleline ? 2 : inline ? 1 : 0}
%%scale ${scale ?? 1}
${musicfont != null ? `%%musicfont ${musicfont}` : '%'}
${color != null ? `%%fgcolor ${color}` : '%'}
${background != null ? `%%bgcolor ${background}` : '%'}
%%maxshrink ${maxshrink ?? 0.4}
${barsperstaff != null ? `%%barsperstaff ${barsperstaff}` : '%'}
%%beamslope 0
%%ornament up
%%tuplets 2 2 0 1
%
%%topspace 0
%%composerspace 0
%%musicspace 0
%%partsspace 0
%%subtitlespace 0
%%textspace 0
%%titlespace 0
%%topmargin 0
%%botmargin 0
%%leftmargin 0
%%rightmargin 0
%%staffsep 20
%%notespacingfactor 1
%`;
}
class Abc2SvgCallbacks {
    barRects;
    abc_svg_output;
    abc_error_output;
    _syms;
    _abc = null;
    keep_remark = true;
    page_format = false;
    // TODO add imagesize "width='100%' height='100%'"
    abcmodel;
    bars = [{ x: 0, time: 0 }];
    last_s = null;
    constructor(barRects = false) {
        this.barRects = barRects;
        this.abc_svg_output = '';
        this.abc_error_output = [];
        this._syms = [];
    }
    set abc(abc) {
        this._abc = abc;
    }
    get symbols() {
        return this._syms;
    }
    static get nextId() {
        return ++Abc2SvgCallbacks.counter;
    }
    get svg() {
        return this.abc_svg_output;
    }
    get errors() {
        return this.abc_error_output;
    }
    img_out = (data) => {
        this.abc_svg_output += data;
    };
    read_file = (fileName) => '';
    anno_start = (music_type, start_offset, stop_offset, x, y, w, h, s) => {
    };
    anno_stop = (music_type, start_offset, stop_offset, x, y, w, h, s) => {
        if (this.barRects && this._abc != null && music_type == 'bar') {
            const lastBar = this.bars.at(-1);
            const rect = {
                x: lastBar.x,
                y: y,
                width: s.x - lastBar.x,
                height: this._abc.sh(h).toFixed(2)
            };
            this._abc.out_svg(`<rect class="bar-rect" data-bar="${this.bars.length - 1}" x="`);
            this._abc.out_sxsy(rect.x, '" y="', rect.y);
            this._abc.out_svg(`" width="${rect.width}" height="${rect.height}"/>\n`);
            this.bars.push({ x: s.x, time: s.time });
        }
        this.last_s = s;
    };
    get_abcmodel = (tsfirst, voice_tb, music_types, info) => {
        this.abcmodel = {
            tsfirst,
            voice_tb,
            music_types,
            info
        };
    };
    /**
     *     0: warning
     *     1: error
     *     other value: fatal error
     */
    errbld = (severity_level, message, file_name, line_number, column_number) => {
        this.abc_error_output.push({
            severity_level, message, file_name, line_number, column_number
        });
    };
    static counter = 0;
}
//# sourceMappingURL=abc2svg.js.map